/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindByScopeIdQueryResponse, FilesControllerFindByScopeIdPathParams, FilesControllerFindByScopeIdQueryParams, FilesControllerFindByScopeId400, FilesControllerFindByScopeId401, FilesControllerFindByScopeId403, FilesControllerFindByScopeId404 } from "../../models/filesController/FilesControllerFindByScopeId";

function getFilesControllerFindByScopeIdUrl(scopeId: FilesControllerFindByScopeIdPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/scopes/${scopeId}/file` as const }  
  return res
}

/**
 * @summary Get a file by scope ID
 * {@link /api/v1/scopes/:scopeId/file}
 */
export async function filesControllerFindByScopeId(scopeId: FilesControllerFindByScopeIdPathParams["scopeId"], params?: FilesControllerFindByScopeIdQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerFindByScopeIdQueryResponse, ResponseErrorConfig<FilesControllerFindByScopeId400 | FilesControllerFindByScopeId401 | FilesControllerFindByScopeId403 | FilesControllerFindByScopeId404>, unknown>({ method : "GET", url : getFilesControllerFindByScopeIdUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}